import React from "react";
import { Card, Table, Tag, Typography } from "antd";
import { PayCircleOutlined } from "@ant-design/icons";
import { cardStyle } from "../styles";

const { Text } = Typography;

const columns = [
  // {
  //   title: "STT",
  //   key: "index",
  //   width: 60,
  //   fixed: 'left',
  //   render: (_, __, index) => index + 1,
  // },
  {
    title: "Mã HD",
    dataIndex: "code",
    key: "code",
    width: 180,
    fixed: 'left',
    render: (code) => <Tag>{code}</Tag>,
  },
  {
    // Tài sản (số nhà) gắn với khoản thu. Ưu tiên tên tài sản đang lưu, thiếu thì lấy
    // charge_target_number ghi thẳng trên khoản thu — khoản thu loại CUSTOMER hoặc dữ
    // liệu cũ không có asset_id nên không phải dòng nào cũng có tài sản.
    title: "Tài sản",
    key: "asset",
    width: 220,
    render: (_, record) => {
      const tenTaiSan = record.asset?.name || record.charge_target_number;

      if (!tenTaiSan) {
        return <Text type="secondary">_</Text>;
      }

      return (
        <div>
          <div style={{ fontWeight: 500 }}>{tenTaiSan}</div>
          {record.asset?.code && (
            <Text type="secondary" style={{ fontSize: 12 }}>
              {record.asset.code}
            </Text>
          )}
        </div>
      );
    },
  },
  {
    title: "Đợt thu",
    key: "collection",
    width: 380,
    render: (_, record) => record.collection?.name || `Đợt thu ${record.code}`,
  },
  {
    title: "Tổng cộng",
    dataIndex: "amount_due",
    key: "amount_due",
    align: "right",
    width: 200,
    render: (amount) => (
      <Text strong style={{ color: "#0070D7" }}>
        {Number(amount || 0).toLocaleString("vi-VN")} ₫
      </Text>
    ),
  },
  {
    title: "Đã thanh toán",
    dataIndex: "amount_paid",
    key: "amount_paid",
    align: "right",
    width: 200,
    render: (amount) => (
      <Text strong style={{ color: "#A8681E" }}>
        {Number(amount || 0).toLocaleString("vi-VN")} ₫
      </Text>
    ),
  },
  {
    title: "Trạng thái",
    dataIndex: "status",
    key: "status",
    width: 200,
    align: "center",
    fixed: 'right',
    render: (status) => {
      const config = {
        PAID: { label: "Đã thanh toán", color: "success" },
        CANCELLED: { label: "Đã hủy", color: "error" },
        UNPAID: { label: "Chưa thanh toán", color: "warning" },
        PARTIAL: { label: "Một phần", color: "processing" },
      };
      const { label, color } = config[status] || { label: status, color: "default" };
      return <Tag color={color}>{label}</Tag>;
    },
  },
];

export default function CollectionTable({ data, pagination, onChange }) {
  return (
    <Card
      title={
        <>
          <PayCircleOutlined style={{ marginRight: 8 }} />
          Thông tin khoản thu
        </>
      }
      style={cardStyle}
    >
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        pagination={{
          ...pagination,
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]}-${range[1]} của ${total}`,
        }}
        onChange={onChange}
        scroll={{ x: "max-content" }}
        size="small"
      />
    </Card>
  );
}
